import AuthService from '../services/AuthService';

export default {
    state: {
        authenticated: !!localStorage.getItem('token'),
        jwt: localStorage.getItem('token'),
        user: null,
        isAdmin: false,
        isUser: false
    },
    getters: {
        isAuth: state => {
            return state.authenticated;
        },
        getUser: state => {
            return state.user;
        },
        isAdmin: state => {
            return state.isAdmin;
        },
        isUser: state => {
            return state.isUser;
        }
    },
    mutations: {
        setAuthenticated(state, header) {
            state.jwt = header;
            state.authenticated = true;
        },
        clearAuthentication(state) {
            state.authenticated = false;
            state.jwt = null;
            state.user = null;
            state.isAdmin = false;
            state.isUser = false;
        },
        setUser(state, user) {
            state.user = user;
        },
        setIsAdmin(state, status) {
            state.isAdmin = status;
        },
        setIsUser(state, status) {
            state.isUser = status;
        }
    },
    actions: {
        async authenticate(context, credentials) {
            return await AuthService.signIn(credentials).then(response => {
                if (response.status === 200 && response.data.token) {
                    AuthService.setToken(response.data.token);
                    AuthService.setRefreshToken(response.data.refresh_token);
                    AuthService.setOnceGlobalToken(response.data.token);
                    context.commit('setAuthenticated', credentials);
                    context.commit('setUser', AuthService.tokenDecode(AuthService.getToken()));
                    context.commit('setIsAdmin', AuthService.isAdmin());
                    context.commit('setIsUser', AuthService.isUser());
                } else {
                    this.clearAuthentication(context.state)
                }
            });
        },
        clearAuthentication(context) {
            context.commit('clearAuthentication')
        },
        setUser(context, userData) {
            context.commit('setUser', userData)
        },
        setIsUser(context, status) {
            context.commit('setIsUser', status);
        },
        setIsAdmin(context, status) {
            context.commit('setIsAdmin', status)
        }
    }
}